export const partnerRequestActionTypes = {
    GET_PARTNER_REQUESTS_SUCCESS: 'GET_PARTNER_REQUESTS_SUCCESS',
    GET_PARTNER_REQUESTS_REQUEST: 'GET_PARTNER_REQUESTS_REQUEST',
    GET_PARTNER_REQUESTS_FAILED: 'GET_PARTNER_REQUESTS_FAILED',
};

export function getPartnerRequests(filter) {
    return { 
        type: partnerRequestActionTypes.GET_PARTNER_REQUESTS_REQUEST,
        payload: filter
    };
}

export function getPartnerRequestsSuccess(partnerRequests) {
    return { 
        type: partnerRequestActionTypes.GET_PARTNER_REQUESTS_SUCCESS, 
        payload: partnerRequests 
    };
}

export function getPartnerRequestsFailed(payload) {
    return { 
        type: partnerRequestActionTypes.GET_PARTNER_REQUESTS_FAILED, 
        payload 
    };
}
